import { onScopeDispose } from 'vue';
import { KycLoader, KycOperator } from '@bs2-bet/kyc/services';
import type {
  KycOperatorContext,
  KycOperatorInstance,
} from '@bs2-bet/kyc/types';

export default defineNuxtPlugin({
  name: 'kyc',
  enforce: 'post',

  setup(nuxtApp: any) {
    const { ApiService } = useApiService();
    const hasContainment = !!(nuxtApp as any).$containment;
    const authAdapter = useAuthAdapter();

    try {
      KycOperator.configure({
        api: ApiService as KycOperatorContext['api'],

        containment: (hasContainment
          ? (nuxtApp as any).$containment
          : KycOperator.context
              .containment) as KycOperatorContext['containment'],

        auth: authAdapter as KycOperatorContext['auth'],
      });
    } catch (error) {
      console.error('[KYC Plugin] ❌ Erro ao configurar KycOperator:', error);
    }

    const kycInstance = KycLoader.instance;

    const operatorInstance = ref<KycOperatorInstance>(kycInstance);

    const removeKycListenerOperator = kycInstance.on('operator', (instance) => {
      operatorInstance.value = instance as KycOperatorInstance;
    });

    // const removeKycListenerCurrent = kycInstance.on('current', (current) => {
    //   const kycStore = useKycStore();

    //   if (current.id) {
    //     kycStore.kycId = current.id;
    //   }
    // });

    const removeKycListenerStatus = kycInstance.on(
      'status',
      ({ status, data }) => {
        const { openToaster } = useLayoutStore();
        const { $i18n } = useNuxtApp();

        if (status === 'REPROVED') {
          return openToaster({
            message: $i18n.t('verification.kyc.failed'),
            type: 'error',
          });
        }

        if (status === 'RETRY') {
          return openToaster({
            message: $i18n.t('verification.kyc.retry'),
            type: 'warning',
          });
        }

        if (status === 'MANUAL_APPROVE_PENDING') {
          return openToaster({
            message: $i18n.t('verification.kyc.title_manual_approve_pending'),
            type: 'info',
          });
        }

        if (status === 'EXPIRED') {
          return openToaster({
            message: $i18n.t('verification.kyc.max_retries'),
            type: 'info',
          });
        }

        if (status === 'SERVICE_UNAVAILABLE') {
          return openToaster({
            message: $i18n.t('general.errors.service_unavailable'),
            type: 'info',
          });
        }

        if (status === 'INTERNAL_ERROR' && data?.message) {
          return openToaster({
            message: data.message,
            type: 'error',
            time: 12000,
            position: 'bottom-right',
          });
        }
      },
    );

    onScopeDispose(() => {
      removeKycListenerOperator();
      removeKycListenerStatus();
      // removeKycListenerCurrent();
    });

    const kyc = new Proxy({} as KycOperatorInstance, {
      get(_, prop: keyof KycOperatorInstance) {
        return operatorInstance.value[prop];
      },
      set(_, prop: string, value) {
        (operatorInstance.value as Record<string, unknown>)[prop] = value;

        return true;
      },
    });

    return {
      provide: {
        kyc,
      },
    };
  },
});
